import { Location, LocationControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author rajkumar rathod
 */
export const usePgAddLocation = () =>
  useMutationWithLoading(async (params: Location & { xTENANTID?: string }) =>
    new LocationControllerApi(getConfigObject()).createLocation(
      params,
      params.xTENANTID
    )
  );
